/**
 * @ngdoc component
 * @name common.account.component:ItxRegister
 * @requires common.newsletter.service:ItxNewsletterSvc
 * @description
 * Register form component.
 */

(function() {

    'use strict';

    var ItxRegisterCmp = {
        bindings: {
            onRegister: '&',
            data: '<',
            options: '<',
            guestTokens: '<'
        },  
        require: {
            'userAccessCtrl': '?^itxUserAccess'
        },
        controller: ItxRegisterCmpCtrl,
        templateUrl: ['$element', '$attrs', function($element, $attrs) {
            return $attrs.template || 'register.component.html';
        }]
    };
    angular.module('itxApp.common')
    .component('itxRegister', ItxRegisterCmp);


    ItxRegisterCmpCtrl.$inject = [
        '$scope',
        '$timeout',
        '$element',
        'ItxErrorMessagesFct',
        'ItxLoaderFct',
        'imAccessService',
        'CmsConfigSvc',
        'ItxNewsletterSvc',
        'ItxTranslateSvc',
        'ItxPhoneSvc',
        'NostromoSvc',
        'UserService',
        '$rootScope',
        'AddressService',
        'CountryService',
        'mdFeelSuscriptionService',
        'DUTTI_CONS',
        'ItxHeaderFct',
        'preCommonCmsConfigSvc',
        'ngDialog'
    ];

    function ItxRegisterCmpCtrl($scope, 
        $timeout, 
        $element, 
        ItxErrorMessagesFct, 
        ItxLoaderFct, 
        imAccessService, 
        CmsConfigSvc,
        ItxNewsletterSvc,
        ItxTranslateSvc, 
        ItxPhoneSvc,
        NostromoSvc,
        UserService,
        $rootScope,
        AddressService,
        CountryService,
        mdFeelSuscriptionService,
        DUTTI_CONS,
        ItxHeaderFct,
        preCommonCmsConfigSvc,
        ngDialog
        ) {

        var _this = this;

        _this.registerModel = {};
        _this.registerModel.isCompany = false;
        _this.registerModel.password = '';
        _this.registerModel.birthdate = '';
        _this.passwordValid = false;
        _this.hasOneNumber = true;
        _this.isLengthMin = true;
        _this.isLowerOneCharacter = true;
        _this.isUpperOneCharacter = true;
        _this.isRepeatCharacter = true;
        _this.passwordFocused = false;
        _this.placeHolderText = {};
        _this.registerExtraFieldBirthdate = false;
        _this.registerExtraFieldProvince = false;

        if (_this.data) {
            _this.registerModel = _this.data;
            _this.registerModel.isCompany = false;
            _this.registerModel.gender = 'F';
            _this.migrationGuestUser = true;
            _this.email = _this.data.email;
        }

        if (_this.options) {
            _this.registerModel = _this.options;
            _this.registerModel.isCompany = false;
        }
        
        _this.registerModel.newsletterAccepted = false;

        _this.countryCode = inditex.iStoreJSON.countryCode;
        _this.phoneCountryCode = inditex.iStoreJSON.details.phoneCountryCode;
        _this.phoneValidationEnabled = ItxPhoneSvc.isEnabled();
        if( _this.phoneValidationEnabled ){
            _this.phoneForm = {
                "code":  '', 
                "phone" : '',
            }
        }
        _this.SMSClicked = false;
        _this.SMSButtonText = 'VERIFY PHONE VIA SMS';
        _this.visibleCodeInput = false;
        _this.serviceDown = false;
        _this.limitExceded = false;
        _this.nifRequired = false;

        _this.isKorea = CountryService.is(DUTTI_CONS.country.KR);
        _this.isTurkey = CountryService.is(DUTTI_CONS.country.TR) || inditex.iCountryCode === 'TK';
        _this.isChina = CountryService.is(DUTTI_CONS.country.CN);
        _this.isGeorgia = CountryService.is(DUTTI_CONS.country.GE);
        _this.isArmenia = CountryService.is(DUTTI_CONS.country.AM);
        _this.isHongKong = CountryService.is(DUTTI_CONS.country.HK);
        
        _this.phoneLoginEnabled = false;
        _this.hideLogin = false;

        _this.isMiddleName = inditex.iStoreJSON.details.isMiddleName;
        _this.isLastName = !_this.isKorea && !_this.isHongKong;
        _this.registerForm = null;
        _this.userEMailRegistration = null;
        _this.isCompanyAllowed = inditex.iStoreJSON.details.isCompanyAllowed;
        _this.enable_pec_receiver = false;

        _this.isCountryFeel = false;

        _this.$onInit = function() {
            _this.sectionsSelected = (_this.preselectedFields && this.preselectedFields.newsletterSections) || [];
            // IMAnalytics Acceso Registro -> desde purchase
            if (inditex.iPage === 'ItxOrderConfirmationPage') {
                imAccessService.createView('acceso', 'registro');
            }
            ItxNewsletterSvc.getOptin().then(function(res){
                _this.optIn = res;
            });

            inditex.getXconfiguracionValue('ENABLE_PEC_AND_RECEIVER_CODE', function(response, value) {
                if(value == 1){
                    _this.enable_pec_receiver = true;
                }
            });

            inditex.getXconfiguracionValue('PHONE_REGISTER_LOGIN_ENABLED', function (status, value) {
                if (value == 1) {
                    _this.phoneLoginEnabled = true;
                }
            });

            if (_this.registerModel.hideLogin) {
                _this.hideLogin = true;
            }

            //_this.passwordValid = true;

            _this.setNifPlaceholder();
            
            if(_this.isGeorgia || _this.isArmenia){
                _this.nifRequired = true;
            }

            // Obtén la configuración de los campos extra
            CmsConfigSvc.getProperty('newsletterregisterbirthdate')
                .then(function(registerExtraFieldBirthdate) {
                    _this.registerExtraFieldBirthdate = registerExtraFieldBirthdate;
                }); 

            CmsConfigSvc.getProperty('newsletterregisterprovince')
                .then(function(registerExtraFieldProvince) {
                    _this.registerExtraFieldProvince = registerExtraFieldProvince;
                });

            // Comprobamos si el servicio de Massimo Dutti Feel está activo
            CmsConfigSvc.getProperty('is_country_feel').then(function (crmActive) {
                if (crmActive) {

                    // Desactivamos los campos de Company
                    _this.isCompanyAllowed = false;
                }
            });

            preCommonCmsConfigSvc.getProperty('is_country_feel').then(function (crmActive) {
                _this.isCountryFeel = crmActive;
            });
        };

        _this.showCompanyFields = function() {
            if(_this.registerModel.isCompany){
                if(_this.showFormParameter('company') && !_this.enable_pec_receiver){
                    return true;
                }
            } else {
                return false;
            }
        }

        _this.setState = function(obj) {
            _this.registerModel.stateCode = obj.code;
            _this.registerModel.stateName = obj.name;
        }

        _this.setDate = function(date) {
            _this.registerModel.birthdate = date;
        }

        _this.launchData = function(data){
            var saved = inditex.getSessionStorage('REGISTER_N');
            if(!saved){
                NostromoSvc.register();
                inditex.setSessionStorage('REGISTER_N',true);
            }
          
        }

        _this.toggleCompany = function(){
            _this.registerModel.isCompany=!_this.registerModel.isCompany
            _this.setNifPlaceholder();
        }

        _this.setNifPlaceholder = function(){
            // NIF placeholder text
            switch(inditex.iCountryCode){
                case 'TR':
                    if(_this.registerModel.isCompany){
                        _this.placeHolderText = 'VKN';
                    } else {
                        _this.placeHolderText = 'TCKN';
                    }
                    break;
                case 'IT':
                    _this.placeHolderText = 'Codice Fiscale / Partita IVA';
                    break;
                case 'AM':
                    _this.placeHolderText = ItxTranslateSvc.translateCms('legacy.CommonErrorFields.input.nationalid');
                    break;
                default:
                    _this.placeHolderText = ItxTranslateSvc.translateCms('legacy.ItxUserRegistrationForm.nif');
            }
        }

        _this.showFormParameter = function (parameter) {
            var country = inditex.iCountryCode;
            if (parameter == 'italy_company' && !_this.enable_pec_receiver) {
                return false;
            } else if (
                parameter == 'company' &&
                ((country == 'IT' && _this.enable_pec_receiver) ||
                    country == 'EG' ||
                    country == 'CO' ||
                    country == 'RS' ||
                    country == 'ID')
            ) {
                return false;
            } else {
                var showParameter = AddressService.getCountryFormParameters(country, parameter);
                return showParameter;
            }
        };

        _this.showSections = function () {
            return (
                _this.registerModel.newsletterAccepted &&
                !(_this.userAccessCtrl && _this.userAccessCtrl.preselectedFields && _this.userAccessCtrl.preselectedFields.newsletterSections)
            );
        };

        _this.showMessageRequired = function(name) {
            return _this.registerForm[name].$dirty || _this.registerForm.$submitted;
        };

        _this.validatePassword = function() {
            if (_this.registerModel.password == undefined) {
                _this.registerModel.password = '';
            }
            var hasNumber = /\d/.test(_this.registerModel.password);
            _this.hasOneNumber = !hasNumber;

            var length = /.{8,}/.test(_this.registerModel.password);
            _this.isLengthMin = !length;

            var patternLowerOneCharacter = new RegExp(".*[a-z]");
            var isLoChar = patternLowerOneCharacter.test(_this.registerModel.password);
            _this.isLowerOneCharacter = !isLoChar;

            var patternUpperOneCharacter = new RegExp(".*[A-Z]");
            var isUpChar = patternUpperOneCharacter.test(_this.registerModel.password);
            _this.isUpperOneCharacter = !isUpChar;

            _this.isRepeatCharacter = !_this.isRepeatChar();

            var passWordValid = _this.isRepeatChar() && !_this.hasOneNumber && !_this.isLengthMin && !_this.isLowerOneCharacter && !_this.isUpperOneCharacter;
            _this.passwordValid = passWordValid;

        }

        _this.isRepeatChar = function() {
            if (_this.registerModel.password == "") {
                return false;
            } else {
                var d = _this.registerModel.password;
                return /^(?!.*(.)\1{3})^.*$/.test(d);
            }
        };

        _this.isSendEnabled = function(){

            if( _this.isChina ){
                return !(_this.registerModel.sensitive_data && _this.registerModel.transfer_data);
            }else{
                return false;
            }
        }

        _this.register = function() {
            _this.registerForm.$setSubmitted();
            if (_this.registerForm.$valid) {
                if (_this.userAccessCtrl && _this.userAccessCtrl.preselectedFields) {
                    _this.registerModel.privacyPolicyFeel = _this.userAccessCtrl.preselectedFields.feelTermsAndConditions;
                    _this.registerModel.newsletterAccepted = Boolean(_this.userAccessCtrl.preselectedFields.newsletterSections);
                    _this.registerModel.sectionsSelected = _this.userAccessCtrl.preselectedFields.newsletterSections;
                }
                var newUser = joyr.user.utils.createEmptyUser();

                if(_this.phoneLoginEnabled) {
                    newUser.logon = newUser.logonConfirm = `${_this.phoneCountryCode}${_this.phoneForm.phone}`;
                } else {
                    newUser.email = newUser.emailConfirm = _this.email;
                }  
                
                newUser.password = newUser.passwordConfirm = _this.registerModel.password;
                newUser.primaryAddress.firstName = _this.registerModel.firstName;
                newUser.primaryAddress.lastName = _this.registerModel.lastName;
                newUser.primaryAddress.gender = _this.registerModel.gender;
                newUser.primaryAddress.isCompany = _this.registerModel.isCompany;
                newUser.primaryAddress.vatin = _this.registerModel.vatin;

                if( inditex.iCountryCode === 'CN' ){
                    newUser.primaryAddress.isCompany = false;
                    newUser.primaryAddress.clientType = 'P';
                }
                if (_this.registerModel.isCompany) {
                    newUser.primaryAddress.company.vatin = _this.registerModel.cif || _this.registerModel.company.vatin;
                    newUser.primaryAddress.company.name = _this.registerModel.companyName || _this.registerModel.company.name;
                    newUser.primaryAddress.company.taxOffice = _this.registerModel.taxOffice;
                    newUser.primaryAddress.pec = _this.registerModel.pec;
                    newUser.primaryAddress.receiverCode = _this.registerModel.receiverCode;
                    if(_this.registerModel.company && _this.registerModel.company.registrationNumber) {
                        newUser.primaryAddress.company.registrationNumber = _this.registerModel.company.registrationNumber;
                    }
                }

                if (_this.isMiddleName) {
                    newUser.primaryAddress.middleName = _this.registerModel.middleName;
                }

                if (CountryService.isWWCountry(newUser.primaryAddress.countryCode)) {
                    newUser.primaryAddress.countryCode = inditex.getLocalStorage('COUNTRY_ISO');
                }

                if (_this.registerModel.privacyPolicyAccepted) {
                    newUser.privacyPolicyAccepted = true;
                }

                // Añadimos la aceptacón de los términos y condiciones de Feel
                if (_this.registerModel.privacyPolicyFeel) {
                    newUser.privacyPolicyFeel = true;
                }

                if (_this.registerModel.newsletterAccepted) {
                    newUser.newsletter = "";
                }

                var options = {};
                if (_this.registerModel.rememberMe) {
                    options.rememberMe = true;
                }
                if (_this.migrationGuestUser) {
                    options.migrationGuestUser = true;
                }
                if (_this.registerModel && _this.registerModel.guestToken && _this.registerModel.orderId) {
                    options.guestToken = _this.registerModel.guestToken;
                    options.orderId = _this.registerModel.orderId;
                }

                if (_this.guestTokens) {
                    newUser.guestTokens = _this.guestTokens;
                    if (options.migrationGuestUser) {
                        delete options.migrationGuestUser;
                    }
                }

                if(_this.phoneForm ){
                    newUser.phone = {
                        "countryCode": _this.phoneCountryCode, 
                        "subscriberNumber" : _this.phoneForm.phone,
                    };
                    newUser.code =  _this.phoneForm.code;
                }

                newUser.primaryAddress.stateCode = _this.registerModel.stateCode;
                newUser.primaryAddress.stateName = _this.registerModel.stateName;
                newUser.primaryAddress.birthdate = _this.registerModel.birthdate;

                if (inditex.iUrlJSON && inditex.iUrlJSON.params.sponsorcode) {
                    if (!_this.isCountryFeel || _this.registerModel.privacyPolicyFeel) {
                        newUser.sponsorCode = inditex.iUrlJSON.params.sponsorcode;
                    }
                }

                ItxLoaderFct.show();
                joyr.rest.xRestRegister(newUser, options)
                    .done(function(data) {
                        // if (!data) { data = newUser }

                        _this.userEMailRegistration = inditex.iUserJSON.email;

                        // IMAnalytics  trigger registrarse_ok
                        imAccessService.eventSessionOK('acceso_registro', 'registrarse_ok');

                        if (newUser.privacyPolicyFeel) {
                            if (
                                _this.userAccessCtrl &&
                                _this.userAccessCtrl.preselectedFields &&
                                _this.userAccessCtrl.preselectedFields.feelTermsAndConditions
                            ) {
                                imAccessService.createEvent('fidelizacion', 'alta_fidelizacion_ok', null, 'fidelizacion');
                            } else {
                                imAccessService.createEvent('acceso_registro', 'alta_fidelizacion_ok');
                            }
                        }

                        if( sessionStorage.getItem('FROM_NEWSLETTER') == true || sessionStorage.getItem('FROM_NEWSLETTER') === 'true' ){
                            _this.registerModel.newsletterAccepted = true;
                            sessionStorage.removeItem('FROM_NEWSLETTER');
                        }

                        // En caso de haber marcado la Newsletter
                        if (_this.registerModel.newsletterAccepted) {
                            var origin = 'web_crea_tu_cuenta';

                            if(inditex.iPage == 'ItxShopCartPage' || inditex.iPage == 'ItxCheckoutPage' || inditex.iPage == 'ItxCheckoutAuthPage' ) {
                                origin = 'web_tunel_crea_tu_cuenta';
                            }
                            ItxNewsletterSvc.subscribe(newUser.email, _this.sectionsSelected, origin, true).then(function() {

                                var kinds = _this.sectionsSelected.map((section) => {
                                    return section.split('_')[1] || '';
                                });
                                var label = kinds.join('|').toLowerCase();

                                if (
                                    _this.userAccessCtrl &&
                                    _this.userAccessCtrl.preselectedFields &&
                                    Boolean(_this.userAccessCtrl.preselectedFields.newsletterSections)
                                ) {
                                    imAccessService.createEvent('fidelizacion', 'alta_newsletter_ok', label, 'fidelizacion');
                                } else {
                                    imAccessService.createEvent('acceso_registro', 'alta_newsletter_ok', label);
                                }
                                // En caso de haber marcado Feel
                                if (_this.registerModel.privacyPolicyFeel) {

                                    // Damos de alta el usario como Feel
                                    mdFeelSuscriptionService.registerCrm(_this.registerModel).then(function () {
                                        // Procesamos el registro
                                        _this.processRegisterWithVIP(newUser, data);
                                    });

                                // Procesamos el registro directamente
                                } else {
                                    _this.processRegisterWithVIP(newUser, data);
                                }
                            });

                        } else {
                            // En caso de haber marcado Feel
                            if (_this.registerModel.privacyPolicyFeel) {

                                // Damos de alta el usario como Feel
                                mdFeelSuscriptionService.registerCrm(_this.registerModel).then(function () {
                                    // Procesamos el registro
                                    _this.processRegister(newUser, data);
                                });

                            // Procesamos el registro directamente
                            } else {
                                _this.processRegister(newUser, data);
                            }
                        }

                        NostromoSvc.registerDone();
                    })
                    .Catch(function (error) {
                        switch (error.errorKey) {
                            case '_ERR_LOGONID_ALREDY_EXIST':
                            case '_APP_PERSON_REGISTER':
                                _this.userAccessCtrl.show('register-already-exist');
                                break;
                            case '_ERR_PHONE_NO_VALIDATE':
                                _this.visibleCodeInput = true;
                                _this.registerForm.code.$setValidity('emptycode', false);
                                break;
                            case '_MAX_NUMBER_SPONSORSHIPS':
                            case '_ERR_SPONSOR_CODE_EXPIRATED':
                            case '_ERR_GENERIC':
                                ItxErrorMessagesFct.add(
                                    ItxTranslateSvc.translateCms(`dev.register.memberGetMember.${error.errorKey}`),
                                    'userAccessCtrl',
                                    'ERROR'
                                );
                                break;
                            default:
                                if (error.message.indexOf('_ERR_VALIDATION') > -1) {
                                    ItxErrorMessagesFct.dialog(error.errorMessage);
                                    _this.registerForm.code.$setValidity('invalidcode', false);
                                } else {
                                    ItxErrorMessagesFct.add(error.errorMessage, 'userAccessCtrl', 'ERROR');
                                }
                                break;
                        }

                        // IMAnalytics trigger event server error
                        imAccessService.createServer('acceso_registro', _this.registerForm, error);
                    })
                    .Finally(function () {
                        ItxLoaderFct.hide();
                        $scope.$apply();
                    });
            } else {
                // IManalytics trigger form error
                imAccessService.createForm('acceso_registro', _this.registerForm);
            }
        };

        _this.$postLink = function() {
            //Reverse firstName and lastName order in CN forms
            $timeout(function() {
                if (inditex.iCountryCode === 'CN') {
                    var $lastName = $element.find('.last-name');
                    if ($lastName.length) {
                        $($lastName).parent().prepend($lastName);
                    }
                }
            });
        };

        _this.openPrivacyPolicy = function() {
            window.open(inditex.getStaticResourceUrl('pdf/privacy_policy/' + inditex.iStoreId + '/privacy_policy-5.pdf'), '_blank');
        };

        _this.back = function() {
            if (_this.userAccessCtrl) {
                _this.userAccessCtrl.closeDialog();
            }
        };

        _this.recoverPassword = function() {
            if (_this.userAccessCtrl) {
                _this.userAccessCtrl.updateLogin(_this.email);
                _this.userAccessCtrl.show('recover-password');
            }
        };

        _this.loginThisAccount = function() {
            if (_this.userAccessCtrl) {
                _this.userAccessCtrl.updateLogin(_this.email);
                _this.userAccessCtrl.show('login');
            }
        };

        _this.getInputsGrid = function() {
            if (_this.isMiddleName) {
                return 'col-sm-4';
            } else {
                return 'col-sm-12';
            }
        };

        _this.$onDestroy = function() {
            ItxErrorMessagesFct.reset('userAccessCtrl', 'ERROR');
        };

        _this.goToUpdateEmail = function() {
            window.location.href = joyr.utils.getCommonPageUrl('ItxMyAccountPage', false, false) + '#/access-data';
            /**
             * IMAnalytics
             */
            imAccessService.createEvent('acceso_registro', 'modificar_email');
        };

      /*  _this.sendSMS = function(){
            _this.registerForm.code.$setValidity("emptycode",true);
            _this.SMSButtonText = 'SENDING CODE...';
            ItxPhoneSvc.sendSMS(_this.email ,_this.registerModel.phone).then(function(response){
                _this.visibleCodeInput = true;
                _this.SMSClicked = true;
                _this.SMSButtonText = 'RESEND CODE';
                setTimeout(function(){
                    _this.SMSClicked = false;
                    $scope.$digest();
                },60000);
            }, function(error){
                if(error.errorKey && error.errorKey.indexOf('_ERR_SMS_SERVICE_DOWN') > -1){
                    _this.serviceDown = true;
                }
                else if(error.errorKey && error.errorKey.indexOf('_ERR_SMS_MAX_RETRIES') > -1){
                    _this.limitExceded = true;
                }
            });
        }*/

        _this.setPhone = function(data){
            _this.phoneForm.code = data.code;
            _this.phoneForm.phone = data.phone;
        }

        /**
         * Función que se ejecuta al procesar el registro de usuario VIP
         */
        _this.processRegisterWithVIP = function (data, userData) {
            if (_this.userAccessCtrl && _this.registerModel.privacyPolicyFeel) {
                UserService.isVipEnabled().then(function (enabled) {
                    if (!enabled) {
                        _this.userAccessCtrl.show('register-success');
                    }
                });
            }

            if (_this.userAccessCtrl) {
                if (_this.registerModel.hasOwnProperty('privacyPolicyFeel') && !_this.registerModel.privacyPolicyFeel) {
                    ngDialog.close();
                } else {
                    _this.userAccessCtrl.show('register-success');
                    imAccessService.createView('acceso', 'registro/confirmacion');
                }
            }

            if (_this.onRegister) {
                _this.onRegister();
            }

            $rootScope.$broadcast('login:success', data);

            ItxHeaderFct.toggleLogin(true);

            const eventOptions = {
                bubbles: true,
                composed: true,
                detail: {
                    extra: {
                        typeEvent: 'login-success',
                        data: userData
                    }
                }
            };
            document.dispatchEvent(new CustomEvent('legacy-event-apollo', eventOptions));
        };

        /**
         * Función que se ejecuta al procesar el registro de usuario
         */
        _this.processRegister = function (data, userData) {
            // Mostramos el popup de registro satisfactorio en caso de no habernos registrado como usuario Feel
            if (_this.userAccessCtrl) {
                if (_this.registerModel.hasOwnProperty('privacyPolicyFeel') && !_this.registerModel.privacyPolicyFeel) {
                    ngDialog.close();
                } else {
                    _this.userAccessCtrl.show('register-success');
                    imAccessService.createView('acceso', 'registro/confirmacion');
                }
            }

            if (_this.onRegister) {
                _this.onRegister();
            }

            $rootScope.$broadcast('login:success', data);

            ItxHeaderFct.toggleLogin(true);

            const eventOptions = {
                bubbles: true,
                composed: true,
                detail: {
                    extra: {
                        typeEvent: 'login-success',
                        data: userData
                    }
                }
            };
            document.dispatchEvent(new CustomEvent('legacy-event-apollo', eventOptions));
        };
    }

    

})();